namespace SP {
    export interface PickProfileOrderInfo {
        id: number;
        orderNo: string;
        referenceNo: string;
        productionItemInfo: ItemInfo;
        productionQuantity: number;
        preferredDeliveryDate: string;
        priority: number;
        recipient: Address;
        lineCount: number;
        itemCount: number;
    }

    export interface PickProfileInfo {
        profile: PickSettingInfo;
        orders: PickProfileOrderInfo[];
    }

    export interface PickSettingInfo {
        id: string;
        name: string;
        maxOrders: number;
        primePicklist: boolean;
        picklistType: SP.PicklistType;
        allowLocationScanPicking: number;
        groupPickSingleScan: boolean;
        printAllLabelOnFinishPickList: boolean;
        appendToteNameToOrderNo: boolean;
        appendToteNameToReference: boolean;
        forceItemBarcodeScanning: boolean;
        forceItemWeighing: boolean;
        allowRefillPicks: boolean;
        autofillPackageFromTote: boolean;
        autoPrintLabel: boolean;
        allowMultiTote: boolean;
        quickPack: boolean;
        forceDeliveryNote: boolean;
        orderType: number;
        scanPackageCollection: boolean;
        scanPickingTrolley: boolean;
        orderCount: number;
        orderCountIfRefill: number;
        orderFifoMode: number;
        oldestOrderDate: string;
        fulfillmentLocation: string;
    }
}